import { of } from 'rxjs';
import { AppointmentFormComponent } from 'src/app/modules/calendar/appointment-form.component.js';
import { CalendarComponent } from '../../modules/calendar/calendar.component.js';
import {
	ICoreRoutes,
	IPageMetadata,
	ISharedData,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';

export type CalendarRouteMode = 'upcoming' | 'past';
export interface ICalendarRouteData {
	mode: CalendarRouteMode;
}

export interface ICalendarRoutes extends ICoreRoutes {
	view: ITypeRoute<
		ICalendarRouteData,
		{
			upcoming: ITypeRouteAction<ICalendarRouteData>;
			past: ITypeRouteAction<ICalendarRouteData>;
		}
	>;
	manage: ITypeRoute<
		ICalendarRouteData,
		{
			new: ITypeRouteAction<undefined>;
		}
	>;
}

export const calendarRoutes: RouteInitializer<ICalendarRoutes> = {
	view: {
		mainPath: 'calendar',
		uniqueId: 'calendar_main',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			const shared: ISharedData<ICalendarRouteData> = {
				data: {
					mode: 'upcoming'
				},
				linkedItems: []
			};

			return of(shared);
		},
		menuItems: (context) => [],
		children: {
			upcoming: {
				processSharedData: (context) => {
					context.sharedData.data.mode = 'upcoming';
					return context.sharedData;
				},
				uniqueId: `calendarUpcoming`,
				component: CalendarComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Upcoming`
					};

					return metadata;
				}
			},
			past: {
				processSharedData: (context) => {
					context.sharedData.data.mode = 'past';
					return context.sharedData;
				},
				uniqueId: `calendarPast`,
				component: CalendarComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Past`
					};

					return metadata;
				}
			}
		}
	},
	manage: {
		mainPath: 'calendar',
		uniqueId: 'calendar_manage',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [],
		children: {
			new: {
				parentRoutes: (context) => [],
				uniqueId: `newAppointment`,
				component: AppointmentFormComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `New`
					};

					return metadata;
				}
			}
		}
	}
};
